import { render } from "./newContact.vue?vue&type=template&id=7839e3b2&scoped=true"
import script from "./newContact.vue?vue&type=script&lang=js"
export * from "./newContact.vue?vue&type=script&lang=js"

import "./newContact.vue?vue&type=style&index=0&id=7839e3b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7839e3b2"]])

export default __exports__